import TranslationDictionaryTrialPlaceholder from '@/shared/assets/images/translation-dictionary-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Unlock Translation Dictionary',
  bulletsHeader: '',
  buttonText: 'Unlock Dictionary',
  content: {
    allowedPlanNames: ['Creator Pro', 'Business'],
    chip: {
      title: 'Get consistent translations with Dictionary and other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'professional content where consistent terminology matters.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'What you’ll get',
      bullets: [
        'Keep brand terms consistent',
        'Set preferred translations once',
        'Avoid wrong translations for names and key phrases',
      ],
    },
  },
  features: [],
  media: {
    src: TranslationDictionaryTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'translationDictionary' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'translationDictionary' }),
  subtitle: 'Keep product names, brand terms, and key phrases translated exactly the way you want.',
};

export const TRANSLATION_DICTIONARY_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
